// extracted by mini-css-extract-plugin
export default {"pageWrap":"le-z","fullWidth":"me-z","heading":"ne-z","fullBleed":"oe-z","hidden":"pe-z"};